import e from"react";var t=function(){return e.createElement("svg",{width:"17",height:"18",viewBox:"0 0 17 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{d:"M0.762207 17.5V0.5H16.7622V17.5H0.762207Z",fill:"#FF66E3"}))};export{t as default};
//# sourceMappingURL=Rectangle.js.map
